const IMAGE_DISPLAYS = {
  big: {
    'mobile-s': { w: 164, h: 100 },
    'mobile-m': { w: 300, h: 200 },
    'mobile-l': { w: 360, h: 200 },
    'tablet-p': { w: 571, h: 496 },
    'tablet-l': { w: 655, h: 496 },
    'desktop': { w: 680, h: 516 }
  },
  small: {
    'mobile-s': { w: 164, h: 100 },
    'mobile-m': { w: 300, h: 200 },
    'mobile-l': { w: 360, h: 200 },
    'tablet-p': { w: 277, h: 210 },
    'tablet-l': { w: 320, h: 210 },
    'desktop': { w: 320, h: 220 }
  },
  thumb: {
    'default': { w: 99, h: 99 }
  }
}

export const DEFAULT_SCOPE = 'us'
export const LANGUAGE_SITE_MAP = {
  en: 'us',
  es: 'cl',
  pt: 'br',
  zh: 'cn'
}
export const SITE_SCOPES = ['us', 'cl', 'pe', 'mx', 'br', 'co', 'cn']
export const SUPPORTED_SCOPES = [...SITE_SCOPES, ...Object.keys(LANGUAGE_SITE_MAP)]

export const scopeToSite = (scope = DEFAULT_SCOPE) => LANGUAGE_SITE_MAP[scope] || scope || DEFAULT_SCOPE

export const buildScopePath = scope => (scope && scope !== DEFAULT_SCOPE ? `/${scope}` : '')

export const getScopeFromUrl = (url, defaultScope = DEFAULT_SCOPE) => {
  if (url) {
    const fragments = url.split('/')
    if (fragments.length < 5) return defaultScope
    if (SUPPORTED_SCOPES.includes(fragments[4].substr(0, 2))) {
      return fragments[4].substr(0, 2)
    }
    return defaultScope
  }
  return defaultScope
}

export const getScope = () => getScopeFromUrl(window.location.href)

export const getSite = () => scopeToSite(getScope())

export const siteToLang = site => {
  const resolvedSite = scopeToSite(site)
  if (['cl', 'pe', 'mx', 'co'].includes(resolvedSite)) return 'es'
  if (resolvedSite === 'us') return 'en'
  if (resolvedSite === 'br') return 'pt'
  if (resolvedSite === 'cn') return 'zh'
  return 'en'
}

export const getProductDestinationUrl = (product = {}, scope = DEFAULT_SCOPE, countryCode = '') => {
  const { url, duplicates = [] } = product
  if (!Array.isArray(duplicates) || duplicates.length === 0) return url

  const normalizedCountryCode = String(countryCode || '').toLowerCase()
  const defaultSite = LANGUAGE_SITE_MAP[siteToLang(scope)]
  const countryProduct = duplicates.find(duplicate => duplicate.site === normalizedCountryCode)
  const defaultProduct = duplicates.find(duplicate => duplicate.site === defaultSite)

  return countryProduct?.url || defaultProduct?.url || url
}

export const getLang = () => siteToLang(getSite())

export const getSiteAndLang = () => {
  const site = getSite()
  const scope = getScope()
  const locale = siteToLang(site)
  return { scope, site, locale }
}

const getImageDimensions = (url, isBig, device) => (
  url.match('thumb_jpg') ? IMAGE_DISPLAYS.thumb['default'] : (isBig ? IMAGE_DISPLAYS.big[device] : IMAGE_DISPLAYS.small[device])
)

export const setSnoopyUrl = ({
  url = '',
  device = 'desktop',
  isBig = false,
  isRetina = false,
  crop = true
}) => {
  if (url === '') return url

  const { w, h } = getImageDimensions(url, isBig, device)
  const width = isRetina ? w * 2 : w
  const height = isRetina ? h * 2 : h

  const paramSign = url.match(/\?/) ? '&' : '?'
  const imgParams = `${paramSign}format=webp&width=${width}&height=${height}&crop=${crop}`
  return url
    .replace('images.adsttc.com', 'snoopy.archdaily.com/images/archdaily')
    .replace('neufert-cdn.archdaily.net', 'snoopy.archdaily.com/images/archdaily/catalog') + imgParams
}
